import { IContextDTO } from '@/modules/scripts/dtos/context.dto';
import { IContext } from '@/modules/scripts/entities/context.entity';

export class ContextMapper {
  static toPresentation(dto: IContextDTO): IContext {
    return {
      audience: dto.publico_alvo,
      topic: dto.tema_central,
      goal: dto.objetivo,
      openingText: dto.texto_abertura,
      closingText: dto.texto_fechamento,
    };
  }

  static toDTO(domain: IContext): IContextDTO {
    return {
      publico_alvo: domain.audience,
      tema_central: domain.topic,
      objetivo: domain.goal,
      texto_abertura: domain.openingText,
      texto_fechamento: domain.closingText,
    };
  }
}
